const expandPainelItemLabelformActions = {
  local: 'Lugar',
  equipment: 'Equipo',
  equipmentReference: 'Punto de referencia',
  service: 'Servicio',
  questionGroup: 'Grupo de la Pregunta',
  questionText: 'Pregunta',
  actionBy: 'Acción creada por',
  sn: 'S/N',
  description: 'Descripción',
  text: 'Sin S/N'
};

export default expandPainelItemLabelformActions;
